module.exports = __webpack_public_path__ + "static/media/9c7531ac-6f6a-4ce9-ae5d-bb58476a96f2_1.0d1e460267fb5ebc25e437b822bb1173.f2d7a62a.jpeg";